export enum IbexaFieldTypeIdentifier {
    ImageAsset = 'ezimageasset',
    ObjectRelation = 'ezobjectrelation',
    RichText = 'ezrichtext',
    Selection = 'sckenhancedselection',
    String = 'ezstring',
    Tags = 'eztags',
}

export default IbexaFieldTypeIdentifier